import React, { Fragment } from 'react';
import { RenderKilogramo, RenderGramos, RenderNumberPercentage } from 'Utils/renderField/renderReadField';

/**
 * Componente para renderizar la tabla de DRC
 * @param {object} props propiedades del componente
 * @returns {JSX.Element} componente de tabla de DRC
 */
export const TablaDRC = (props) => {
    const { fields, setDRCTemp, openModal,
        loadDataModalDRC, updateData,
        variacionDRC, mostrarVariacionDRC } = props;
    return (
        <div className="new-table-wrapper mt-3">
            <table>
                <thead>
                    <tr>
                        <th />
                        <th className='text-right'>PESO MUESTRA</th>
                        <th className='text-right'>PESO CREPA</th>
                        <th className='text-right'>PH1</th>
                        <th className='text-right'>PH2</th>
                        <th className='text-right'>PH3</th>
                        {variacionDRC.aplica && mostrarVariacionDRC ?
                            <Fragment>
                                <th className='text-right'>PS1 ORIGINAL</th>
                                <th className='text-right'>PS2 ORIGINAL</th>
                                <th className='text-right'>PS3 ORIGINAL</th>
                                <th className='text-right datos-drc-solidos-edicion__tbl-long-name'>PS1 CON VARIACIÓN DRC</th>
                                <th className='text-right datos-drc-solidos-edicion__tbl-long-name'>PS2 CON VARIACIÓN DRC</th>
                                <th className='text-right datos-drc-solidos-edicion__tbl-long-name'>PS3 CON VARIACIÓN DRC</th>
                            </Fragment>
                            :
                            <Fragment>
                                <th className='text-right'>PS1</th>
                                <th className='text-right'>PS2</th>
                                <th className='text-right'>PS3</th>
                            </Fragment>
                        }
                        <th className='text-right'>DRC1</th>
                        <th className='text-right'>DRC2</th>
                        <th className='text-right'>DRC3</th>
                        <th className='text-right'>DRC PROMEDIO</th>
                        <th>HORA INGRESO</th>
                        <th>HORA SALIDA</th>
                        <th>LABORATORISTA</th>
                    </tr>
                </thead>
                <tbody>
                    {fields.map((pago, index) => {
                        const dato_actual = fields.get(index); // Pago actual
                        let todos = fields.getAll();
                        todos[index]['index'] = index; //Mutar cada fila par agregarle el index

                        const celdaClassName = (dato_actual.activo !== undefined && dato_actual.activo === false) ? 'tachado' : '';

                        return (
                            <tr key={index} >
                                <td label="ACCIONES">
                                    <div className="table-actions">
                                        <img src={require('assets/img/icons/borrar.png')} alt="Borrar"
                                            title="Borrar" className="action_img"
                                            onClick={() => {
                                                if (dato_actual.hasOwnProperty('id')) {
                                                    dato_actual.activo = false;
                                                    updateData(dato_actual, 'drc');
                                                    setDRCTemp('test', false)
                                                } else
                                                    fields.remove(index)
                                            }}
                                        />
                                        <img src={require('assets/img/icons/editar.png')} alt="Editar"
                                            title="Editar" className="action_img"
                                            onClick={() => {
                                                loadDataModalDRC(dato_actual);
                                                openModal("drc");
                                                if (dato_actual.laboratorista) setDRCTemp('laboratorista', dato_actual.laboratorista);
                                                else setDRCTemp('laboratorista', dato_actual.laboratorista_asignado);
                                            }}
                                        />
                                    </div>
                                </td>
                                <td
                                    label="PESO MUESTRA"
                                    className={`${celdaClassName} td--no-wrap text-right`}>
                                    <RenderKilogramo value={dato_actual.peso_muestra} />
                                </td>
                                <td
                                    label="PESO CREPA"
                                    className={`${celdaClassName} td--no-wrap text-right`}>
                                    <RenderKilogramo value={dato_actual.peso_crepa} />
                                </td>
                                <td
                                    label="PESO HUMEDO 1"
                                    className={`${celdaClassName} td--no-wrap text-right`}>
                                    <RenderGramos value={dato_actual.peso_humedo_1} />
                                </td>
                                <td
                                    label="PESO HUMEDO 2"
                                    className={`${celdaClassName} td--no-wrap text-right`}>
                                    <RenderGramos value={dato_actual.peso_humedo_2} />
                                </td>
                                <td
                                    label="PESO HUMEDO 3"
                                    className={`${celdaClassName} td--no-wrap text-right`}>
                                    <RenderGramos value={dato_actual.peso_humedo_3} />
                                </td>
                                {variacionDRC.aplica && mostrarVariacionDRC ?
                                    <Fragment>
                                        <td
                                            label="PS1 ORIGINAL"
                                            className={`${celdaClassName} td--no-wrap text-right`}>
                                            <RenderGramos value={dato_actual.peso_seco_1} />
                                        </td>
                                        <td
                                            label="PS2 ORIGINAL"
                                            className={`${celdaClassName} td--no-wrap text-right`}>
                                            <RenderGramos value={dato_actual.peso_seco_2} />
                                        </td>
                                        <td
                                            label="PS3 ORIGINAL"
                                            className={`${celdaClassName} td--no-wrap text-right`}>
                                            <RenderGramos value={dato_actual.peso_seco_3} />
                                        </td>
                                        <td
                                            label="PS1 CON VARIACIÓN DRC"
                                            className={`${celdaClassName} td--no-wrap text-right`}>
                                            <RenderGramos value={dato_actual.peso_seco_1} />
                                        </td>
                                        <td
                                            label="PS2 CON VARIACIÓN DRC"
                                            className={`${celdaClassName} td--no-wrap text-right`}>
                                            <RenderGramos value={dato_actual.peso_seco_2} />
                                        </td>
                                        <td
                                            label="PS3 CON VARIACIÓN DRC"
                                            className={`${celdaClassName} td--no-wrap text-right`}>
                                            <RenderGramos value={dato_actual.peso_seco_3} />
                                        </td>
                                    </Fragment>
                                    :
                                    <Fragment>
                                        <td
                                            label="PS1"
                                            className={`${celdaClassName} td--no-wrap text-right`}>
                                            <RenderGramos value={dato_actual.peso_seco_1} />
                                        </td>
                                        <td
                                            label="PS2"
                                            className={`${celdaClassName} td--no-wrap text-right`}>
                                            <RenderGramos value={dato_actual.peso_seco_2} />
                                        </td>
                                        <td
                                            label="PS3"
                                            className={`${celdaClassName} td--no-wrap text-right`}>
                                            <RenderGramos value={dato_actual.peso_seco_3} />
                                        </td>
                                    </Fragment>
                                }
                                <td
                                    label="DRC 1"
                                    className={`${celdaClassName} td--no-wrap text-right`}>
                                    {dato_actual.drc_promedio_1 ? <RenderNumberPercentage value={parseFloat(dato_actual.drc_promedio_1)} /> : '--'}
                                </td>
                                <td
                                    label="DRC 2"
                                    className={`${celdaClassName} td--no-wrap text-right`}>
                                    {dato_actual.drc_promedio_2 ? <RenderNumberPercentage value={parseFloat(dato_actual.drc_promedio_2)} /> : '--'}
                                </td>
                                <td
                                    label="DRC 3"
                                    className={`${celdaClassName} td--no-wrap text-right`}>
                                    {dato_actual.drc_promedio_3 ? <RenderNumberPercentage value={parseFloat(dato_actual.drc_promedio_3)} /> : '--'}
                                </td>
                                <td
                                    label="DRC PROMEDIO"
                                    className={`${celdaClassName} td--no-wrap text-right`}>
                                    {dato_actual.drc_promedio_total ? <RenderNumberPercentage value={parseFloat(dato_actual.drc_promedio_total)} /> : '--'}
                                </td>

                                <td
                                    label="HORA INGRESO"
                                    className={`${celdaClassName} td--no-wrap`}>
                                    <span>{dato_actual.hora_ingreso} </span>
                                </td>
                                <td
                                    label="HORA SALIDA"
                                    className={`${celdaClassName} td--no-wrap`}>
                                    <span>{dato_actual.hora_salida} </span>
                                </td>
                                <td
                                    label="LABORATORISTA"
                                    className={`${celdaClassName}`}>
                                    <span>{dato_actual.laboratorista_nombre ? dato_actual.laboratorista_nombre : dato_actual.laboratorista.nombre} </span>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
};
